/**
 * Production-safe logging utility
 * Can be completely disabled via environment variable
 */

type LogLevel = 'log' | 'warn' | 'error' | 'info';

class Logger {
  private isDevelopment = process.env.NODE_ENV === 'development';
  private isLoggingDisabled = process.env.REACT_APP_DISABLE_LOGS === 'true';

  private shouldLog(): boolean {
    return this.isDevelopment && !this.isLoggingDisabled;
  }

  log(...args: any[]): void {
    if (this.shouldLog()) {
      console.log(...args);
    }
  }

  warn(...args: any[]): void {
    if (this.shouldLog()) {
      console.warn(...args);
    }
  }

  error(...args: any[]): void {
    // Log errors unless explicitly disabled
    if (!this.isLoggingDisabled) {
      console.error(...args);
    }
  }

  info(...args: any[]): void {
    if (this.shouldLog()) {
      console.info(...args);
    }
  }

  debug(...args: any[]): void {
    if (this.shouldLog()) {
      console.log('[DEBUG]', ...args);
    }
  }

  // For production debugging with feature flag
  forceLog(...args: any[]): void {
    console.log(...args);
  }
}

export const logger = new Logger();

// Legacy support - can be used as drop-in replacement
export const devConsole = {
  log: (...args: any[]) => logger.log(...args),
  warn: (...args: any[]) => logger.warn(...args),
  error: (...args: any[]) => logger.error(...args),
  info: (...args: any[]) => logger.info(...args),
};